import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { Task } from '@/api/tasks/types'
import { api } from '@/api'
import type { Reward } from '@/interfaces/user.interface'

export const useTasksStore = defineStore('tasks', () => {
  const tasksState = ref<Task[]>()
  const dailyRewardsState = ref<Reward[]>()

  const fetchTasks = async () => {
    const { dailyRewards, tasks } = await api.tasks.list()
    tasksState.value = tasks
    dailyRewardsState.value = dailyRewards
  }

  return { tasks: tasksState, dailyRewards: dailyRewardsState, fetchTasks }
})
